import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { compose } from 'ramda';

import connect from 'app/libs/connect';
import { fetchSeries } from 'app/features/series/actions';
import withDispatchOnMount from 'app/enhancers/withDispatchOnMount';
import S from 'app/features/landing/seriesCollection/components/SeriesCollection.styled';
import SeriesThumbnail from 'app/features/landing/seriesCollection/components/SeriesThumbnail';
import Heading from 'app/components/layout/Heading.styled';
import {
  titleKey,
  displayedSeries,
} from 'app/features/landing/seriesCollection/selectors';

const UI = ({ titleKey, series }) => (
  <S.CardsHolder>
    <Heading size="l" as={S.CardsHolder.Title}>
      <FormattedMessage id={titleKey} />
    </Heading>
    <S.CardsHolder.Feed>
      {series.map(({ id, name, image }) => (
        <SeriesThumbnail key={id} name={name} image={image} />
      ))}
    </S.CardsHolder.Feed>
  </S.CardsHolder>
);

UI.propTypes = {
  titleKey: PropTypes.string.isRequired,
  series: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      seriesId: PropTypes.string,
      image: PropTypes.string,
    }),
  ),
};

UI.defaultProps = {
  series: [],
};

UI.displayName = 'SeriesCollection';

const state = { series: displayedSeries, titleKey };

const SeriesCollection = compose(
  withDispatchOnMount(fetchSeries),
  connect(state),
)(UI);

export { UI };

export default SeriesCollection;
